import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
import { Injectable, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { LocalStorageService } from '../../services/local-storage/local-storage.service';
import { AuthService } from '../../services/auth/auth.service';

/**
 * This manage the custom id login from next fest
 * To don't let that user logged in with that get into certain paths
 */
@Injectable({
  providedIn: 'root', // or specify the module where the guard is provided
})
export class CustomIdLoginGuard implements CanActivate {
  private router = inject(Router);
  private localStorage = inject(LocalStorageService);
  private authService = inject(AuthService);


  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> {
    if (!this.localStorage.get('withCustomId')) {
      return of(true); // check first level flags
    } else {
      this.authService.logout().then((res) => {
        this.router.navigate(['/auth/login']);
      });
      return of(false);
    }
  }
}
